import { render } from "./walk.vue?vue&type=template&id=ea2692c4"
import script from "./walk.vue?vue&type=script&lang=js"
export * from "./walk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__